import { Expose } from 'class-transformer';

export default class AvailabilityCheckResultFormError {
    status: string[] = []
    note: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}